













import {Component, Prop, Vue} from 'vue-property-decorator';
import {ProductItem} from '@/types';
import SupportIcon from '@/assets/icons/icn-support.svg';
import {getZendeskAuthURL, ZENDESK_NEW_TICKET_PART} from '@/constants/urls';
import {ProductType} from '@/constants/productTypes';
import {getValidToken} from '@/components/auth/token';

@Component({
  components: {
    SupportIcon,
  },
})
export default class ProductSupportLink extends Vue {
  @Prop() public item: ProductItem;

  public async openZendeskSupportUrl() {
    const {model: {category}, serialNumber} = this.item;
    const token = await getValidToken();
    const authURL = getZendeskAuthURL(token);
    const url = category === ProductType.DRONE
        ? `${authURL}${ZENDESK_NEW_TICKET_PART}?dronesn=${serialNumber}`
        : `${authURL}${ZENDESK_NEW_TICKET_PART}`;

    window.open(url, '_blank');
    this.$gtag.event('open-zendesk-ticket', {
      'event_category': 'support-request',
      'event_label': 'Support Request',
    });
  }

  public async mailToReseller() {
    if (this.item.reseller) {
      window.open(`mailto:${this.item.reseller.email}`, '_blank');
      this.$gtag.event('mailto-reseller', {
        'event_category': 'support-request',
        'event_label': 'Support Request',
      });
    }
  }

  public async parrotSupport() {
    window.open('https://www.parrot.com/us/support/hotline', '_blank');
    this.$gtag.event('parrot-business-products', {
      'event_category': 'support-request',
      'event_label': 'Support Request',
    });
  }

}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Shared/ProductSupportLink/ProductSupportLink.vue